import { useTranslation } from 'next-i18next';
import { SetStateAction, Dispatch, useRef } from 'react';
import { Scrollbar, Mousewheel, FreeMode } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperClass } from 'swiper/types';
import Button from '@components/Button/Button';
import Icon from '@components/icons/Icon';
import styles from '@features/showrooms/sections/ShowroomsSection/Components/Filters/Filters.styles';
import Heading from '@components/Heading/Heading';
import { IShoowroomFilters, IPointOfPresenceGroupNames } from '@features/checkout/typescript';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/scrollbar';
type PropsType = {
  active: boolean;
  setActive: Dispatch<SetStateAction<boolean>>;
  buttonFilters: boolean;
  filters: IShoowroomFilters;
  handleFilters: (filters: IShoowroomFilters) => void;
  setActiveShowroomFiltersInfo: Dispatch<SetStateAction<boolean>>;
  setActiveServiceFiltersInfo: Dispatch<SetStateAction<boolean>>;
  showroomsNames: IPointOfPresenceGroupNames;
};
const Filters = ({
  active,
  setActive,
  buttonFilters,
  filters,
  handleFilters,
  setActiveShowroomFiltersInfo,
  setActiveServiceFiltersInfo,
  showroomsNames
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const swiperInstance = useRef<SwiperClass>(null);
  const handleChangeFilters = (indexFilters: number, indexFilter: number) => {
    const newFilters = filters.map((groupFilters, i) => groupFilters.map((activeFilter, k) => i === indexFilters && indexFilter === k ? !activeFilter : activeFilter));
    handleFilters(newFilters);
  };
  return <div sx={styles.container}>
      {buttonFilters && <Button variant="iconOnly" onClick={() => setActive(!active)} addSx={styles.buttonFilters(active)}>
          <Icon icon="FilterUnselected" size="16px" />
        </Button>}
      <div sx={styles.filtersContainer(active)}>
        <Heading h={4} headingType={4} size={16} pb={16} mobile>
          <span>{t('showroomMapFiltr')}</span>
          <Button variant="iconOnly" onClick={() => setActiveShowroomFiltersInfo(true)}>
            <Icon icon="InfoOutline" size="16px" />
          </Button>
        </Heading>
        <div sx={styles.filtersWrapper}>
          <Swiper direction="horizontal" modules={[Scrollbar, Mousewheel, FreeMode]} scrollbar={{
          draggable: false,
          hide: true
        }} onSwiper={swiper => {
          swiperInstance.current = swiper;
        }} followFinger slidesPerView="auto" freeMode mousewheel>
            <SwiperSlide>
              <Button variant="outlined" size="micro" addSx={styles.activeButton(filters[0][0])} onClick={() => handleChangeFilters(0, 0)}>
                <Icon icon="Interiors" size="24px" />
                {showroomsNames && showroomsNames?.VOX_INTERIORS ? showroomsNames.VOX_INTERIORS : t('shoowroomMapFilters.interiors')}
              </Button>
              <Button variant="outlined" size="micro" addSx={styles.activeButton(filters[0][1])} onClick={() => handleChangeFilters(0, 1)}>
                <Icon icon="Furniture" size="24px" />
                {showroomsNames && showroomsNames?.VOX_FURNITURES ? showroomsNames.VOX_FURNITURES : t('shoowroomMapFilters.furnitureTitle')}
              </Button>
              <Button variant="outlined" size="micro" addSx={styles.activeButton(filters[0][2])} onClick={() => handleChangeFilters(0, 2)}>
                <Icon icon="Door" size="24px" />
                {showroomsNames && showroomsNames?.VOX_DIP ? showroomsNames.VOX_DIP : t('shoowroomMapFilters.dipTitle')}
              </Button>
              {/* <Button
                variant="outlined"
                size="micro"
                addSx={styles.activeButton(filters[0][3])}
                onClick={() => handleChangeFilters(0, 3)}
               >
                <Icon icon="Voxbox" size="24px" />
                {showroomsNames && showroomsNames?.VOXBOX_STUDIO
                  ? showroomsNames.VOXBOX_STUDIO
                  : t('shoowroomMapFilters.voxboxTitle')}
               </Button> */}
            </SwiperSlide>
          </Swiper>
        </div>

        <Heading h={4} headingType={4} size={16} pb={16} mobile>
          <span>{t('showroomMapFiltrService')}</span>
          <Button variant="iconOnly" onClick={() => setActiveServiceFiltersInfo(true)}>
            <Icon icon="InfoOutline" size="16px" />
          </Button>
        </Heading>

        <div sx={styles.filtersWrapper}>
          <Swiper direction="horizontal" modules={[Scrollbar, Mousewheel, FreeMode]} scrollbar={{
          draggable: false,
          hide: true
        }} onSwiper={swiper => {
          swiperInstance.current = swiper;
        }} followFinger slidesPerView="auto" freeMode mousewheel>
            <SwiperSlide>
              <Button variant="outlined" size="micro" addSx={styles.activeButton(filters[1][0])} onClick={() => handleChangeFilters(1, 0)}>
                {t('shoowroomMapFilters.freeInteriorDesign')}
              </Button>
              <Button variant="outlined" size="micro" addSx={styles.activeButton(filters[1][1])} onClick={() => handleChangeFilters(1, 1)}>
                {t('shoowroomMapFilters.designInVoxboxVR')}
              </Button>
              {/* <Button
                variant="outlined"
                size="micro"
                addSx={styles.activeButton(filters[1][2])}
                onClick={() => handleChangeFilters(1, 2)}
               >
                {t('shoowroomMapFilters.materialLibrary')}
               </Button> */}
              {/* <Button
                variant="outlined"
                size="micro"
                addSx={styles.activeButton(filters[1][3])}
                onClick={() => handleChangeFilters(1, 3)}
               >
                {t('shoowroomMapFilters.architectZone')}
               </Button> */}
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </div>;
};
export default Filters;